<template>
  <div id="app">
    <!-- <Header></Header> -->
    <div class="qrcode">
      <QrCode v-if="!tag"></QrCode>
    </div>
    <router-view> </router-view>
    <!-- <Footer></Footer> -->
  </div>
</template>
<script>
import Header from "./views/components/Header.vue";
import Footer from "./views/components/Footer.vue";
import QrCode from "./views/components/QrCode.vue"; //二维码组件
import { perfix } from '../utils/common.js'
export default {
  name: "App",
  data() {
    return {
      tag:perfix()  
    };
  },
  components: {
    Header,
    Footer,
    QrCode,
  },
  created(){
    console.log(this.tag);
  }
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
#app {
  .qrcode {
    position: fixed;
    right: 0px;
    top: 400px;
    z-index: 100;
  }
}
</style>
